import { render, staticRenderFns } from "./ProformainvoicesOther.vue?vue&type=template&id=75f3e8ae&"
import script from "./ProformainvoicesOther.vue?vue&type=script&lang=js&"
export * from "./ProformainvoicesOther.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports